const tabs = document.querySelectorAll('.tabs-container__header__tab');
const tabContents = document.querySelectorAll('.tabs-container__tab');
const mobileBtn = document.querySelector('.tabs-container__mobile-button');

if(tabs.length > 0) {
    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            tabs.forEach((tabBtn) => tabBtn.classList.remove('--active'));
            tabContents.forEach((tc) => tc.classList.remove('--active'));
    
            tab.classList.add('--active');
            tabContents[index].classList.add('--active');
        });
    });
    
    tabs[0].click();

    mobileBtn.addEventListener('click', () => {
        document.querySelector('.tabs-container__header').scrollLeft += 80;
    })
}
